<template>
  <div>
    <HistoryLogCom :fullNode="fullNode"/>

    <el-table :data="tableData"
              class="issue-invoice-table"
              border>
      <el-table-column prop="receipt_apply_id"
                       label="开票单ID"
                       width="80"/>
      <el-table-column prop="invoice_applied_at"
                       label="申请时间"
                       width="100"/>
      <el-table-column label="状态"
                       width="80">
        <template slot-scope="scope">
          {{ statusLabel(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column prop="submit_admin"
                       label="申请人"
                       width="100"/>
      <el-table-column prop="invoice_time"
                       label="发票日期"
                       width="100"/>
      <el-table-column prop="payment_term_days"
                       label="账期时间"
                       width="80">
        <template slot-scope="scope">
          {{ scope.row.payment_term_days }}天
        </template>
      </el-table-column>
      <el-table-column prop="system_collection_end_date"
                       label="系统预估回款日期"
                       min-width="110"/>
      <el-table-column prop="adjusted_collection_date"
                       label="沟通后的回款日期"
                       min-width="110"/>
      <el-table-column label="操作"
                       fixed="right"
                       width="120">
        <template slot-scope="scope">
          <button-gutter>
            <el-button type="primary"
                       size="mini"
                       @click="goToDetail(scope.row.receipt_apply_id)">
              查看详情
            </el-button>
            <el-button type="warning"
                       size="mini"
                       @click="openFollowDialog(scope.row)">
              回款跟进
            </el-button>
          </button-gutter>
        </template>
      </el-table-column>
    </el-table>

    <!-- 回款跟进弹窗 -->
    <el-dialog title="回款跟进"
               :visible.sync="followDialogVisible"
               append-to-body
               width="600px"
               :close-on-click-modal="false">
      <el-form ref="followForm"
               :model="followForm"
               :rules="followRules"
               label-width="150px">
        <el-form-item label="系统预估回款日期">
          <span>{{ followSystemEndDate || '-' }}</span>
        </el-form-item>
        <el-form-item label="调整回款日期"
                      prop="adjusted_collection_date">
          <el-date-picker v-model="followForm.adjusted_collection_date"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择新的回款日期"
                          style="width: 100%;"/>
        </el-form-item>
        <el-form-item label="调整原因">
          <el-input v-model="followForm.adjusted_collection_reason"
                    type="textarea"
                    :rows="3"
                    maxlength="220"
                    show-word-limit
                    placeholder="请输入调整原因（选填）"/>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="followDialogVisible = false">取消</el-button>
        <el-button type="primary"
                   @click="handleFollowSubmit">确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import HistoryLogCom from '@views/project/node-views/HistoryLogCom.vue'
import { invoiceApply } from '@views/invoice-apply/invoice-apply.store'

export default {
  components: {HistoryLogCom},
  mixins: [],
  props: {
    fullNode: {
      type: Object,
      default: () => {},
    },
    projectId: {
      type: String,
      default: '0',
    }
  },
  data () {
    return {
      invoiceList: [],
      followDialogVisible: false,
      followSystemEndDate: '',
      followForm: {
        id: null,
        adjusted_collection_date: '',
        adjusted_collection_reason: '',
      },
      followRules: {
        adjusted_collection_date: [
          {required: true, message: '请选择调整回款日期', trigger: 'change'},
          {validator: this.validateAdjustedDate, trigger: 'change'},
        ],
      },
    }
  },
  created () {
    this.fetchInvoices()
  },
  computed: {
    receiptInfo () {
      return _.get(this.fullNode, 'project_node.node_result.receipt_info', {}) || {}
    },
    projectNode () {
      return _.get(this.fullNode, 'project_node', {}) || {}
    },
    // history 形如 {5145: "2026-04-15 12:40:03", 5146: "2026-09-30 15:52:36"}
    history () {
      return _.get(this.fullNode, 'project_node.node_result.history', {}) || {}
    },
    // 从历史记录的 key 中提取开票申请 id 列表
    invoiceIds () {
      return Object.keys(this.history).map(id => Number(id))
    },
    // 复用开票模块的状态选项
    statusOptions () {
      return invoiceApply.state.options.status
    },
    tableData () {
      if (this.invoiceList.length) {
        return this.invoiceList.map(item => this.buildRow(item))
      }
      return []
    },
  },
  watch: {},
  methods: {
    // 页面打开时调用接口，按历史记录中的 id 拉取开票申请
    fetchInvoices () {
      const ids = this.invoiceIds
      if (!ids.length) return
      request.common('getInvoiceByIdsApi', {ids})
        .then(({data}) => {
          this.invoiceList = data
        })
        .catch(() => {
          this.invoiceList = []
        })
    },
    buildRow (item) {
      const id = item.id || item.receipt_apply_id
      const historyTime = id != null ? this.history[id] : ''
      const submitName = item.initiator_name || item.submit_admin_name || '-'
      const submitId = item.initiator_id || item.submit_admin_id
      const submitAdmin = submitId ? `${submitName}/${submitId}` : submitName
      return {
        project_id: this.fullNode.project_id || this.projectId || '-',
        node_name: this.fullNode.name || '开票',
        receipt_apply_id: id || '-',
        invoice_applied_at: historyTime || item.created_at || item.invoice_applied_at || '-',
        submit_admin: `${submitAdmin}/${item.initiator}`,
        system_collection_end_date: item.system_collection_end_date || '-',
        adjusted_collection_date: item.adjusted_collection_date || '-',
        invoice_time: item.invoice_time ? String(item.invoice_time).slice(0, 10) : '-',
        status: item.status,
        payment_term_days: item.payment_term_days,
        operate_time: historyTime || item.updated_at || this.projectNode.node_finished_time || '-',
      }
    },
    // 根据状态值返回 store 中定义的标签
    statusLabel (status) {
      if (status == null) return '-'
      const opt = this.statusOptions.find(o => o.value === Number(status))
      return opt ? opt.label : '-'
    },
    // 新标签页打开开票申请详情
    goToDetail (id) {
      const routeData = this.$router.resolve({
        path: `/invoice-apply/detail/${id}`,
        query: {type: 'detail', from: 'apply'},
      })
      window.open(routeData.href, '_blank')
    },
    // 打开回款跟进弹窗
    openFollowDialog (row) {
      this.followSystemEndDate = row.system_collection_end_date && row.system_collection_end_date !== '-' ? row.system_collection_end_date : ''
      this.followForm = {
        id: row.receipt_apply_id,
        adjusted_collection_date: null,
        adjusted_collection_reason: '',
      }
      this.followDialogVisible = true
      this.$nextTick(() => {
        this.$refs.followForm && this.$refs.followForm.clearValidate()
      })
    },
    // 校验：调整回款日期需晚于系统自动计算的回款日期
    validateAdjustedDate (rule, value, callback) {
      const sysEnd = this.followSystemEndDate
      if (sysEnd && sysEnd !== '-' && value) {
        const d1 = new Date(value)
        const d2 = new Date(sysEnd)
        if (!isNaN(d1.getTime()) && !isNaN(d2.getTime()) && d1.getTime() <= d2.getTime()) {
          callback(new Error(`新预估回款日期需晚于系统预估回款日期（${sysEnd}）`))
          return
        }
      }
      callback()
    },
    // 提交回款跟进
    handleFollowSubmit () {
      this.$refs.followForm.validate(valid => {
        if (!valid) return
        request.common('extendPayDaysApi', this.followForm)
          .then(() => {
            this.$message.success('保存成功')
            this.followDialogVisible = false
            this.fetchInvoices()
          })
          .catch(() => {})
      })
    },
  },
}
</script>

<style scoped>
.issue-invoice-table {
  width: 100%;
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/project/node-views/ProjectIssueInvoiceView.vue